<template>
  <content-loader :height="103.5" :width="645">
    <circle cx="22.5" cy="22.5" r="22.5" />
    <rect x="60" y="8" rx="0" ry="0" width="570" height="95.5" />
    <polygon points="60,8 49,19 60,30" />
  </content-loader>
</template>

<script>
import ContentLoader from '@/components/contentLoaders/ContentLoader'

export default {
  components: {
    ContentLoader,
  },
}
</script>
